@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="ProjectTransferSuccessList"
    [filterable]="true"
    (filterChange)="filterProjectTransferSuccessList($event)"
    [(ngModel)]="ProjectTransferSuccesses"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="form-control"
    textField="name"
    valueField="id"
    [data]="ProjectTransferSuccessList"
    [(ngModel)]="ProjectTransferSuccess"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
